"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullContextError = void 0;
/**
 * Thrown when a React context which we require to be not null was null.
 */
class NullContextError extends Error {
    constructor(contextName, providerName) {
        super(`${contextName} was null; missing <${providerName}>?`);
        this.name = 'NullContextError';
    }
}
exports.NullContextError = NullContextError;
//# sourceMappingURL=jsx.js.map